import { store, useAppSelector } from "@store";
import { closeDialog } from "@store/dialogs";

export const IMPORT_DIALOG_ID = "file-to-storydoc-dialog";

export const closeImportDialog = () =>
  store.dispatch(closeDialog(IMPORT_DIALOG_ID));

export const isImportDialogOpen = () =>
  store.getState().dialogs.some((d) => d.id === IMPORT_DIALOG_ID);

export const useIsImportDialogOpen = () =>
  useAppSelector((s) => s.dialogs.some((d) => d.id === IMPORT_DIALOG_ID));
